// Sentry service surface for feature code. Use this instead of importing
// `@sentry/vue` directly — keeps the third-party adapter pinned to one place
// and lets us swap providers (or no-op tests) without touching callers.

import * as Sentry from '@sentry/vue'

export const SentryService = {
  setUser(id: string, email?: string): void {
    Sentry.setUser({ id, ...(email ? { email } : {}) })
  },

  clearUser(): void {
    Sentry.setUser(null)
  },

  captureException(error: unknown, context?: Record<string, unknown>): void {
    Sentry.captureException(error, context ? { extra: context } : undefined)
  },

  captureMessage(message: string, level: Sentry.SeverityLevel = 'info'): void {
    Sentry.captureMessage(message, level)
  },

  setTag(key: string, value: string | number | boolean): void {
    Sentry.setTag(key, value)
  },
} as const
